import {StoreType} from '../../../types/SharedTypes';

export const userParamsSelector = (state: StoreType) => {
  return state.userReducer.params;
}

export const allUsersSelector = (state: StoreType) => {
  return state.userReducer.userResponse;
}